/**
 * T040: useSignIn Hook
 * Mutation hook for sign-in flow
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { signIn, type SignInInput } from '@/services/auth'
import { useAuthStore } from '@/stores/auth'
import { queryKeys } from '@/lib/query-keys'

export function useSignIn() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { setUser } = useAuthStore()

  return useMutation({
    mutationFn: (input: SignInInput) => signIn(input),
    onSuccess: (data) => {
      setUser(data.user)
      queryClient.setQueryData(queryKeys.auth.me(), data)
      navigate({ to: '/prompts' })
    },
  })
}
